// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1G7-H","signatureBlock":"Footer_signatureBlock__23vaq","signature":"Footer_signature__3a538"};